import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Sonntagabends auf der Suche nach einer Idee für Montag.', 'Material aus zehn verschiedenen Quellen zusammengesucht.', 'Projekte scheitern am fehlenden Material.', 'Unsicher, wie man Kunst überhaupt bewertet.', 'Kein roter Faden über die Klassenstufen hinweg.'];
const after = ['Fertige Stunden, sofort einsetzbar.', 'Ein Band für jede Klassenstufe — von Klasse 1 bis 10.', 'Materiallisten mit günstigen Alternativen für alles.', 'Beobachtungsbögen und Bewertungsraster inklusive.', 'Ein aufeinander aufbauendes Curriculum über zehn Jahre.'];
const highlights = [['600', 'Seiten'], ['8 Einheiten', 'pro Band'], ['100%', 'druckbar & digital']];
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-186" data-mp="248gl9ibj1t88">
      <Reveal className="mx-auto max-w-5xl" data-id="element-187" data-mp="206v25f8egipl">
        <div className="mx-auto max-w-3xl text-center" data-id="element-188" data-mp="2086gua3dvavh">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-189" data-mp="fakhlu37smyc">
            Ein besserer Weg, Kunst zu unterrichten
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-brand-navy md:text-[2.75rem]" data-id="element-190" data-mp="5cwkwym1t5dj">
            Von der leeren Kunststunde zur{' '}
            <span className="font-script italic text-brand-orange" data-id="element-191" data-mp="ac93h75vzqab">
              sicheren Kunstlehrkraft.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-192" data-mp="130epdx8oflbq">
            Jeder Band nimmt dir die Vorbereitung ab — mit fertigen Stunden,
            Materiallisten und Bildfolgen für jeden Arbeitsschritt. So kannst du
            dich auf das Wesentliche konzentrieren: das Unterrichten und die
            Freude an der Kunst.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-line overflow-hidden rounded-2xl border border-brand-line bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-193" data-mp="3dsga9mjlm3nb">
          {highlights.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-194" data-mp="1fbee6auz8xz2">
              <strong className="block font-display text-2xl font-extrabold leading-none text-brand-orange" data-id="element-195" data-mp="1aje96401vevm">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.1em] text-brand-gray" data-id="element-196" data-mp="15j0855wv9573">
                {label}
              </span>
            </div>)}
        </div>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-197" data-mp="wmhl2abbgbif">
          <Comparison title="Vorher" items={before} positive={false} data-id="element-198" data-mp="rmd12ab78yng" />
          <Comparison title="Mit Kunst Startklar" items={after} positive data-id="element-199" data-mp="mmgvi6musz5s" />
        </div>
        <p className="mt-8 text-center font-script text-sm italic text-brand-gray" data-id="element-200" data-mp="2lzcmik29gn2n">
          Ein komplettes Kunst-Curriculum, das deine Vorbereitung auf wenige
          Minuten verkürzt.
        </p>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className="rounded-3xl border border-brand-line bg-brand-alt p-7 shadow-sm md:p-9" data-id="element-201" data-mp="2y9kitvq9gi3x">
      <h3 className="mb-6 font-display text-xl font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-202" data-mp="338nkd6718675">
        {title}
      </h3>
      <ul className="space-y-3" data-id="element-203" data-mp="26j69mct6ztyl">
        {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-204" data-mp="2ajzwr3yt94qf">
            <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-orange/10 text-brand-orange' : 'bg-brand-gray/10 text-brand-gray'}`} data-id="element-205" data-mp="2akhxodwf474o">
              <Icon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-206" data-mp="2kg2yi8pr31cu" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-207" data-mp="3r0cb4i47gmlz">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}